/**
 * Swym → localStorage Wishlist Bridge
 * Runs silently alongside Swym on live. When Swym loads a customer's
 * wishlist, copies product handles into doi_wishlist localStorage
 * so the custom wishlist system is pre-populated for the switch.
 *
 * Safe: read-only on Swym side, additive on localStorage side.
 * Runs once per session (sessionStorage flag prevents repeat work).
 */
(function () {
  'use strict';

  var LOCAL_KEY = 'doi_wishlist';
  var SESSION_FLAG = 'doi_wishlist_synced';

  // Only run once per browser session
  if (sessionStorage.getItem(SESSION_FLAG)) return;

  function getLocalHandles() {
    try {
      var raw = localStorage.getItem(LOCAL_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveLocalHandles(handles) {
    try {
      localStorage.setItem(LOCAL_KEY, JSON.stringify(handles));
    } catch (e) { /* quota — degrade silently */ }
  }

  function syncSwymToLocal(swat) {
    swat.fetch(function (products) {
      if (!products || !products.length) {
        sessionStorage.setItem(SESSION_FLAG, '1');
        return;
      }

      var localHandles = getLocalHandles();
      var added = 0;

      products.forEach(function (item) {
        // Swym items have du (URL) like "/products/handle-name" or full URL
        var handle = '';
        if (item.du) {
          var parts = item.du.split('/products/');
          if (parts.length > 1) {
            handle = parts[parts.length - 1].split('?')[0].split('#')[0];
          }
        }
        // Fallback: some Swym configs use empi (external product ID) or dt (display title)
        if (!handle && item.sku) {
          handle = item.sku;
        }

        if (handle && localHandles.indexOf(handle) === -1) {
          localHandles.push(handle);
          added++;
        }
      });

      if (added > 0) {
        saveLocalHandles(localHandles);
      }

      sessionStorage.setItem(SESSION_FLAG, '1');
    });
  }

  // Hook into Swym's callback system
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(function (swat) {
    // Small delay to let Swym fully initialize
    setTimeout(function () {
      syncSwymToLocal(swat);
    }, 2000);
  });
})();
